/* Keep cart navigation in the existing native drawer, including bookmarked /cart links. */
(() => {
  const openCart = async (trigger) => {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return false;
    await customElements.whenDefined('cart-drawer');
    drawer.show(trigger || document.querySelector('.cart-drawer-button'));
    return true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/\/cart\/?$/.test(url.pathname) || url.search || !document.getElementById('CartDrawer')) return;
    event.preventDefault();
    // Existing aria-controls links already use the theme's native toggle listener.
    if (link.getAttribute('aria-controls') !== 'CartDrawer') openCart(link);
  }, true);
  const restoreCart = async () => {
    const url = new URL(window.location.href);
    if (url.searchParams.get('open_cart') !== '1') return;
    if (await openCart()) {
      url.searchParams.delete('open_cart');
      window.history.replaceState(window.history.state, '', url.href);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', restoreCart, {once:true});
  else restoreCart();
})();
